import uniqid from 'uniqid'

// default position of origin and Rotation of origin
const defaultPosition = [0, 0, 0]
const defaultRotation = [0, 0, 0]

// Voice editor default values
let defaultVoiceIndex = 25
let defaultVoiceVolume = 1

// Animation editor default values
let defaultAnimationIndex = 0
let defaultNumberOfLoops = 1

// 0.06361 is provided by Z and indicates the amount of time per character when speaking
var timePerCharacter = 0.06361

// note this method is duplicated in AnimationTab.js
function addNewAnimationElement (editor, selected) {
  console.log(`settings tab: ${editor.animationItems[defaultAnimationIndex].animationId}`)
  let elementToAdd = {
    id: uniqid(),
    animation: {
      name: editor.animationItems[defaultAnimationIndex].name,
      animationId: editor.animationItems[defaultAnimationIndex].animationId,
      iOS: editor.animationItems[defaultAnimationIndex].asset_bundle.iOS.fileURL || 'N/A',
      Android: editor.animationItems[defaultAnimationIndex].asset_bundle.Android.fileURL || 'N/A',
      startTime: selected.start,
      endTime: determineAnimationEndTime(editor, selected.start),
      loopCount: defaultNumberOfLoops,
      destination: {
        position: defaultPosition,
        rotation: defaultRotation
      },
      elements: []
    }
  }
  selected.elements.push(elementToAdd)
  return elementToAdd
}

function addNewVoiceElement (editor, selected) {
  let text = 'Enter Voice Text'
  let elementToAdd = {
    id: uniqid(),
    line: {
      type: 'Specific',
      text: text,
      startTime: selected.start,
      endTime: determineVoiceElementEndTime(text, selected.start),
      voiceName: editor.voiceItems[defaultVoiceIndex].audio.audioName,
      voiceEffect: 'None',
      voiceVolume: defaultVoiceVolume
    }
  }
  selected.elements.push(elementToAdd)
  return elementToAdd
}

function determineAnimationEndTime (editor, startTime) {
  return (parseFloat(editor.animationItems[defaultAnimationIndex].duration) * defaultNumberOfLoops) + startTime
}

function determineVoiceElementEndTime (text, startTime) {
  let timeForText = (text.length * timePerCharacter) + 1
  return startTime + timeForText
}

export { addNewVoiceElement, addNewAnimationElement, defaultPosition, defaultRotation }



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/libs/util.js
// module id = mIaG
// module chunks = 1